import { render, staticRenderFns } from "./CategoryTitle.vue?vue&type=template&id=eb0b5fba&"
import script from "./CategoryTitle.vue?vue&type=script&lang=js&"
export * from "./CategoryTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports